import configureStore from './store/configureStore';

// get token from Legacy
let accessToken;
let tokenExpiratedAt;
let userId;

if (window.gtg) {
    ({ accessToken, tokenExpiratedAt, userId } = window.gtg);
}

const parsedUserId = userId && userId !== 'null' ? Number(userId) : undefined;

const store = configureStore({
    auth: {
        accessToken,
        expiresAt: tokenExpiratedAt,
        userId: Number.isFinite(parsedUserId) ? parsedUserId : undefined
    }
});

export default store;
